import React from "react"
import { Outlet } from "react-router-dom"
import GuestFooter from "layoutsV2/client/GuestFooter"
import withDefaultErrorBoundary from "modules/errors/HOCs/withDefaultErrorBoundary"
import DefaultErrorBoundary from "modules/errors/DefaultErrorBoundary"
import { Layout } from "antd"
import GuestHeader from "../GuestHeader"

const { Content } = Layout

function LandingLayout() {
  return (
    <Layout style={{ minHeight: "100vh" }}>
      <GuestHeader />
      <Content style={{ flex: 1, display: "flex", flexDirection: "column" }}>
        <DefaultErrorBoundary>
          <Outlet />
        </DefaultErrorBoundary>
      </Content>
      <GuestFooter />
    </Layout>
  )
}

export default withDefaultErrorBoundary(LandingLayout)
